import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { formatMovementData } from './contants';

import { MovementItemResponsiveProps } from '.';

export const MovementItemMobile: React.FC<MovementItemResponsiveProps> = (props) => {
  const data = formatMovementData(props);
  return (
    <VStack py={Spacing['inline.xxxs']} space={Spacing['inline.nano']}>
      {data.map(({ label, value }) => (
        <HStack key={label} justifyContent="space-between" alignItems="center" w="full">
          <Text fontSize={Typography['fontsize.md']}>{label}</Text>
          <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
            {value}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
};
